import { jsx as _jsx } from "react/jsx-runtime";
import { ArrowRight2px, Sizes } from "@/components/icon/IconList";
import { mixpanelEvent } from "@/lib/mixpanels/mixpanel";
import { Button } from "@bookips/solvook-ui-library";
import { Typography, alpha, useTheme } from "@mui/material";
import useHandoutProductStore from "src/store/relatedProduct";
const GuideInfo = {
    view: {
        link: "https://solvookguide.oopy.io/print-agent-guide",
        text: "출력 가능한 PC인지 확인하세요",
        eventName: "Printer Guide"
    },
    download: {
        link: "https://solvookguide.oopy.io/pdf",
        text: "PDF 다운로드 방법을 확인하세요",
        eventName: "Pdf Download Guide"
    },
    download_origin: {
        link: "https://solvookguide.oopy.io/pdf",
        text: "다운로드 방법을 확인하세요",
        eventName: "Download Guide"
    }
};
const GuideButton = ()=>{
    const theme = useTheme();
    const { selectedPurchaseOption  } = useHandoutProductStore((state)=>({
            selectedPurchaseOption: state.selectedPurchaseOption
        }));
    return /*#__PURE__*/ _jsx(Button, {
        variant: "text",
        endIcon: /*#__PURE__*/ _jsx(ArrowRight2px, {
            size: Sizes.small,
            color: theme.palette.secondary.main
        }),
        sx: {
            color: "secondary.main",
            mt: 1,
            width: "100%",
            borderRadius: "6px",
            "&:hover": {
                backgroundColor: alpha(theme.palette.grey["300"], 0.2)
            }
        },
        href: GuideInfo[selectedPurchaseOption].link,
        target: "_blank",
        onClick: ()=>{
            //mx-6
            mixpanelEvent("Guide Button Clicked", {
                "Guide Categories": GuideInfo[selectedPurchaseOption].eventName,
                "Guide URL": GuideInfo[selectedPurchaseOption].link
            });
        },
        children: /*#__PURE__*/ _jsx(Typography, {
            variant: "body2",
            sx: {
                color: "secondary.main"
            },
            children: GuideInfo[selectedPurchaseOption].text
        })
    });
};
export default GuideButton;
